import React, { useState, useEffect } from "react";
import { Box, CircularProgress, Stack } from "@mui/material";
import styled from "@emotion/styled";
import BtnPrimary from "../../../../../../component/PrimaryButton";
import { fetchEmployeeDetailsById } from "../../../../../../services/employee";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PlaceIcon from "@mui/icons-material/Place";
import {getLegalUnitList, getOrgDepartments, getOrgEmployees} from "../../../../../../services/globalData";
import { useNotify } from "../../../../../../component/NotificationProvider";

import { tokens, displayFont } from "../../../../../../theme";
const TextBox = styled(Box)({
  wordBreak: "break-word",
  display: "block",
  width: "100%",
  textAlign: "center",
});

const StyledOuterBox = styled(Box)({
  boxShadow: "0 16px 40px -20px rgba(42,29,34,0.22)",
});

const MainBox = styled(Box)({
  height: "100vh",
  width:"100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const OnboardingBox = styled(Box)({
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  textAlign: "center",
  width:"100%"
});

const ContactInfo = ({ icon, value }) => (
  <Box
    width="100%"
    display="flex"
    alignItems="center"
    fontSize="1rem"
    padding="1rem"
  >
    <span style={{ marginRight: "0.5rem", marginTop: "0.25rem" }}>{icon}</span>
    <span>{value}</span>
  </Box>
);

export default ({ loadNextPage }) => {
  const notify = useNotify();
  const [employeeDetails, setEmployeeDetails] = useState({});
  const employee = (getOrgEmployees() || []).find(employee => employee._id === employeeDetails?.reportingTo);
  const department = (getOrgDepartments() || []).find(department => department._id === employeeDetails?.department);
  const location = (getLegalUnitList() || []).find(legalUnit => legalUnit._id === employeeDetails?.location);
  const [loading,setLoading]=useState(false);

  useEffect(() => {
    const employeeId = sessionStorage.getItem("employeeId");
    if (employeeId) {
      fetchEmployeeDetails(employeeId);
    }
  }, []);

  const fetchEmployeeDetails = async (employeeId) => {
    setLoading(true);
    try {
      const res = await fetchEmployeeDetailsById(employeeId);
      if(res.success){
        setEmployeeDetails(res.data);
      } else {
        notify.error(res?.message || "Failed to load employee details");
      }
    } catch (error) {
      notify.error(error?.message || "Failed to load employee details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainBox>
      <StyledOuterBox
        width="75%"
        bgcolor={tokens.card}
        margin="auto"
        borderRadius="12px"
        padding="2.25rem"
      >
        <Stack
          paddingBlock="1rem"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
      {
        loading?(
            <CircularProgress/>
        ):(
          <>
            <OnboardingBox bgcolor="#8C3B5E" padding="1rem">
              <TextBox
                color={tokens.onPrimary}
                fontFamily={displayFont} fontWeight={700} fontSize="1.75rem"
                fontWeight="500"
              >
                Onboarding Invite Sent to{" "}
                {`${employeeDetails.fname} ${employeeDetails.lname}`}
              </TextBox>
              <TextBox color={tokens.onPrimary} fontSize="0.875rem">
                Onboarding link has been sent to user's registered email address
                with the below-mentioned face card.
              </TextBox>
            </OnboardingBox>

            {/* First Row */}
            <Stack
              direction="row"
              justifyContent="space-around"
              bgcolor="#FBF2EC"
              width="100%"
              marginBottom=".156rem"
            >
              <ContactInfo
                icon={
                  <MailOutlineIcon
                    style={{ color: "#8C3B5E", fontFamily: displayFont, fontWeight: 600, fontSize: "1.25rem" }}
                  />
                }
                value={employeeDetails.email}
              />
              <ContactInfo
                icon={
                  <LocalPhoneIcon
                    style={{ color: "#8C3B5E", fontFamily: displayFont, fontWeight: 600, fontSize: "1.25rem" }}
                  />
                }
                value={employeeDetails.phone}
              />
              <ContactInfo
                icon={
                  <PlaceIcon style={{ color: "#8C3B5E", fontSize: "1.25rem" }} />
                }
                value={location?.name}
              />
            </Stack>

            {/* Second Row */}
            <Stack
              direction="row"
              justifyContent="space-around"
              bgcolor="#FBF2EC"
              width="100%"
            >
              {[
                { label: "Employee ID", value: employeeDetails.aliasId },
                { label: "Designation", value: employeeDetails.designation },
                { label: "Department", value: department?.name },
                { label: "Reporting To", value: employee?.fname+" "+employee?.lname},
              ].map((item, index) => (
                <Stack key={index} direction="column" alignItems="center">
                  <TextBox
                    fontSize="1rem"
                    fontWeight={500}
                    color={tokens.textMuted}
                  >
                    {item.label}
                  </TextBox>
                  <TextBox
                    fontSize="1rem"
                    color="#2A1D22"
                  >
                    {item.value}
                  </TextBox>
                </Stack>
              ))}
            </Stack>

            <Box marginTop="2.25rem" width="20rem">
              <BtnPrimary to="/app/employees" sx={{width:"100%", borderRadius: "8px", margin:"auto"}}>Done</BtnPrimary>
            </Box>
          </>
          )
        }
        </Stack>
      </StyledOuterBox>
    </MainBox>
  );
};
